import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CreateOrEditProductCategoryRequest } from '../../../Data/ProductCategory';
import { dictionary } from '../../../dictionary';
import { NotificationType } from '../../../redux/initialState';
import { addNotification } from '../../../redux/notifications/notificationsActionCreator';
import { hospitalService } from '../../../Services/HospitalService';
import { FormFlow, FormFlowStepComponent } from '../../../Shared/FormFlow/FormFlow';
import { routes } from '../../../Utils/routes';
import { ProductCategoryForm } from '../shared/ProductCategoryForm';

const ProductCategoryFormWrapper: FC<FormFlowStepComponent<CreateOrEditProductCategoryRequest>> = ({ FormActionsComponent, onFormStepComplete }) =>
  <ProductCategoryForm FormActionsComponent={FormActionsComponent} onFormStepComplete={onFormStepComplete} />;

export const CreateProductCategory: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCancel = () => history.push(routes.productCategories.index);
  const onComplete = async (request: CreateOrEditProductCategoryRequest) => {
    try {
      await hospitalService.createProductCategory(request);
      dispatch(addNotification(NotificationType.success, dictionary.CREATE_PRODUCT_CATEGORY_SUCCESS));
      history.push(routes.productCategories.index);
    } catch (exception: any) {
      if (exception?.response?.status === 409) {
        dispatch(addNotification(NotificationType.error, exception.response.data.message));
      } else {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_PRODUCT_CATEGORY_ERROR));
      }
    }
  };

  return (
    <FormFlow<CreateOrEditProductCategoryRequest>
      onComplete={onComplete}
      onCancel={onCancel}
      completeButtonLabel={dictionary.CREATE_PRODUCT_CATEGORY_SUBMIT_BTN}
      steps={[
        { pageHeader: dictionary.CREATE_PRODUCT_CATEGORY_PAGE_HEADER, component: ProductCategoryFormWrapper },
      ]}
    />
  );
};
